import { ValidationRule } from 'react-hook-form'

export enum MultiSubPromptType {
  CHOICE_SINGLE = 'prompt_choice_single',
  ADDRESS = 'prompt_address',
  TEXT = 'prompt_text',
}

type PrefilledValue = null | string | boolean | number | (string | boolean | number)[]

interface ItemProps {
  title: string
  placeholder_text?: string
  required?: boolean | string | ValidationRule<boolean>
  member_app_visible?: boolean
  provider_app_visible?: boolean
  sender?: string | null
  utterance?: string | null
  version?: string
  showRequiredAsterisk?: boolean
  prefilled_values?: PrefilledValue
  payload?: unknown
}

export interface PromptChoiceSingleItemProps extends ItemProps {
  type: string
  choices: Choice[]
  choices_display_variant?: string
}

export interface Choice {
  display: string
  id: string
  payload?: Payload
  description?: string
}

export interface Payload {
  slots: unknown
}

export interface PromptTextItemProps extends ItemProps {
  type: string
  text_type: string
}

export interface PromptAddressItemProps extends ItemProps {
  type: string
  place_type: string
}

export type MultiSubPromptItem =
  | PromptChoiceSingleItemProps
  | PromptTextItemProps
  | PromptAddressItemProps
